export { LanguageSwitcherModule } from './language-switcher.module';
